/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

export const useEmailTemplateSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z.object({
        id: z.number().optional(),
        model_id: z.number().int().positive(t('Model is required')),
        model_name: z.string().trim().min(1, t('Model is required')),
        name: z.string().trim().min(1, t('Name is required')).max(120, t('Name must be at most 120 characters')),
        subject: z.string().trim().min(1, t('Subject is required')).max(255, t('Subject must be at most 255 characters')),
        content: z.string().trim().min(1, t('Content is required')),
        category: z.string().optional(),
    }), [t])
}

export type EmailTemplateInputs = z.infer<ReturnType<typeof useEmailTemplateSchema>>
